export default "__VITE_ASSET__bBFboYpw__"